export default __webpack_public_path__ + "16f416b10cd243d6e07b0dda1c42b342.svg";